import { FC } from 'react';

import { carmaClientLegacy } from 'src/services/instance/carmaClientLegacy';

import { SetLocationPopupMicrocopyProps } from '../../SetLocationPopup.types';
import { EnterLocationForm } from '../EnterLocationForm/EnterLocationForm';
import { LocationResponse } from './SetLocation.types';

const searchLocation = (userInput: string) =>
  carmaClientLegacy.get<LocationResponse>(`/location/post-codes?search=${userInput}`).then(({ data }) => data);

export interface SetLocationProps {
  microcopy: SetLocationPopupMicrocopyProps;
  onChange: (value: any) => void;
}

export const SetLocation: FC<SetLocationProps> = ({ microcopy, onChange }) => (
  <EnterLocationForm microcopy={microcopy} onChange={onChange} searchLocation={searchLocation} />
);
